/**
 * 颜色数组
 * @type {string[]}
 */
export const colors = ['#136eff', '#e69200', '#00d04c', '#FFC62A', '#BE8AE8', '#F89BBA', '#EF7579', '#FFE471', '#86DE84', '#44D6E7', '#595D7F', '#00BB8A', '#5001B9', '#88B601'];
/**
 * 状态可选列表
 * @type {[{label: string, value: number},{label: string, value: number}]}
 */
export const availableOptions = [{label: '有效', value: true}, {label: '无效', value: false}];
export const statusEffective = 'effective';
/**
 * 状态可选列表
 * @type {[{label: string, value: string},{label: string, value: string}]}
 */
export const statusOptions = [{label: '有效', value: statusEffective}, {label: '无效', value: 'invalid'}];
/**
 * 布尔值下拉选项
 * @type {[{label: string, value: number},{label: string, value: number}]}
 */
export const booleanOptions = [{label: '是', value: true}, {label: '否', value: false}];
/**
 * 公共类
 * @type {string}
 */
export const typePublics = 'publics';
/**
 * 村居类
 * @type {string}
 */
export const typeVillager = 'villager';
/**
 * 共建类
 * @type {string}
 */
export const typeConUnit = 'conUnit';
/**
 * 类型下拉选项
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
export const typeOptions = [{label: '公共类', value: typePublics}, {label: '村居类', value: typeVillager}, {label: '共建类', value: typeConUnit}];
/**
 * 可认领
 * @type {string}
 */
export const plotStatusClaimable = 'claimable';
/**
 * 已认领
 * @type {string}
 */
export const plotStatusClaimed = 'claimed';
/**
 * 可认领选项
 * @type {{label: string, value: string}}
 */
export const plotStatusClaimableOption = {label: '可认领', value: plotStatusClaimable};
/**
 * 已认领选项
 * @type {{label: string, value: string}}
 */
export const plotStatusClaimedOption = {label: '已认领', value: plotStatusClaimed};
/**
 * 维护中选项
 * @type {{label: string, value: string}}
 */
export const plotStatusMainteningOption = {label: '维护中', value: 'maintening'};
/**
 * 未开放选项
 * @type {{label: string, value: string}}
 */
export const plotStatusNotOpenOption = {label: '未开放', value: 'notOpen'};
export const plotStatusLocked = 'locked';
/**
 * 土地状态下拉选项
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
export const plotStatusOptions = [plotStatusClaimableOption, plotStatusClaimedOption, plotStatusMainteningOption, plotStatusNotOpenOption, {label: '已锁定', value: plotStatusLocked}];
/**
 * 土地状态下拉选项
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
export const plotStatusOptions2 = [plotStatusClaimableOption, {label: '已认领', value: plotStatusClaimed, disabled: true}, plotStatusMainteningOption, plotStatusNotOpenOption, {label: '已锁定', value: plotStatusLocked, disabled: true}];
/**
 * 版本类型
 * @type {[{label: string, value: string},{label: string, value: string}]}
 */
export const versionTypeOptions = [{label: '新增', value: 'add'}, {label: '修改', value: 'update'}];
/**
 * 上传文件的默认限制提示
 * @type {string}
 */
export const commonTopTip = '<div>最多只能上传10个附件，支持上传pdf\\jpg\\png\\word\\excel\\rar\\zip</div><div class="top-tip-red">单文件/图片大小不允许超过100M</div>';
/**
 * 共建单位联系人
 * @type {string}
 */
export const citizenConUnit = 'conUnit';
/**
 * 角色
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string}]}
 */
export const citizenRoleOptions = [{label: '个人', value: 'publics'}, {label: '共建单位联系人', value: citizenConUnit}, {label: '村民', value: 'villager'}];
/**
 * 提示
 * @type {string}
 */
export const MESSAGE_INFO = 'INFO';

/**
 * 警告
 * @type {string}
 */
export const MESSAGE_WARN = 'WARN';

/**
 * 错误
 * @type {string}
 */
export const MESSAGE_ERROR = 'ERROR';

/**
 * 继续操作
 * @type {string}
 */
export const MESSAGE_OPERATION_CONTINUE = 'continue';

/**
 * 返回修改
 * @type {string}
 */
export const MESSAGE_OPERATION_MODIFY = 'modify';

/**
 * 关闭
 * @type {string}
 */
export const MESSAGE_OPERATION_CLOSE = 'close';
export const agreementPlot = 'plot';
/**
 * 协议类型可选列表
 * @type {[{label: string, value: string},{label: string, value: string}]}
 */
export const agreementTypeOptions = [{label: '地块认领协议', value: agreementPlot}, {label: '用户协议及隐私条款', value: 'user'}, {label: '管理制度', value: 'manage'}];
/**
 * 草稿
 * @type {string}
 */
export const progressDraft = 'draft';
/**
 * 支付待确认
 * @type {string}
 */
export const progressConfirm = 'confirm';
/**
 * 申请成功
 * @type {string}
 */
export const progressSuccess = 'success';
/**
 * 申请待审核
 * @type {string}
 */
export const progressReview = 'review';
/**
 * 已到期
 * @type {string}
 */
export const progressOverdue = 'overdue';
/**
 * 进度类型可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const progressDraftOption = {label: '草稿', value: 'draft'};
export const progressReviewOption = {label: '申请待审核', value: progressReview};
export const progressConfirmOption = {label: '支付待确认', value: progressConfirm};
export const progressSuccessOption = {label: '申请成功', value: 'success'};
export const progressFailedOption = {label: '申请失败', value: 'failed'};
export const progressOverdueOption = {label: '已到期', value: progressOverdue};
export const progressOptions = [progressDraftOption, progressReviewOption, progressConfirmOption, progressSuccessOption, progressFailedOption, progressOverdueOption];
/**
 * 审核进度类型可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const reviewProgressOptions = [{label: '审核通过', value: 'pass'}, {label: '审核驳回', value: 'reject'}];
/**
 * 支付进度类型可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const payProgressOptions = [{label: '支付完成', value: 'complete'}, {label: '逾期未支付', value: 'overdue'}];
/**
 * 现金
 * @type {{label: string, value: string}}
 */
export const payWayCashOption = {label: '现金', value: 'cash'};
/**
 * 银行转账
 * @type {{label: string, value: string}}
 */
export const payWayBankOption = {label: '银行转账', value: 'bank'};
/**
 * 微信支付
 * @type {string}
 */
export const payWayWechat = 'wechat';
/**
 * 微信支付
 * @type {{label: string, value: string}}
 */
export const payWayWechatOption = {label: '微信支付', value: payWayWechat};
/**
 * 支付方式类型可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const payWayOptions = [payWayCashOption, payWayBankOption, payWayWechatOption];
/**
 * 支付方式类型可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{disabled: boolean, label: string, value: string}]}
 */
export const payWayOptions2 = [payWayCashOption, payWayBankOption, {label: '微信支付', value: payWayWechat, disabled: true}];
/**
 * 消息模版类型可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const msgTemplateTypeOptions = [{label: '通知', value: 'notice'}, {label: '公告', value: 'announce'}];
/**
 * 消息状态-草稿
 * @type {string}
 */
export const msgStatusDraft = 'draft';
/**
 * 消息状态-已发布
 * @type {string}
 */
export const msgStatusPublished = 'published';
/**
 * 消息状态可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const msgStatusOptions = [{label: '草稿', value: msgStatusDraft}, {label: '已发布', value: msgStatusPublished}];
/**
 * 消息读取状态可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const readStatusOptions = [{label: '已读', value: true}, {label: '未读', value: false}];
/**
 * 退押金
 * @type {string}
 */
export const depositOut = 'out';
/**
 * 退款状态可选列表
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const depositBizTypeOptions = [{label: '全退款', value: 'allOut'}, {label: '退押金', value: depositOut}];